import { TIERS } from '../constants'
const { TIER_ONE, TIER_TWO, TIER_THREE, TIER_FOUR, TIER_FIVE, TIER_SIX } = TIERS

const imagePaths = {
  [TIER_ONE]: 'https://static.nrk.no/dh/module/plast-quiz/whales/v3/tier-one.png',
  [TIER_TWO]: 'https://static.nrk.no/dh/module/plast-quiz/whales/v3/tier-two.png',
  [TIER_THREE]:
    'https://static.nrk.no/dh/module/plast-quiz/whales/v3/tier-three.png',
  [TIER_FOUR]: 'https://static.nrk.no/dh/module/plast-quiz/whales/v3/tier-four.png',
  [TIER_FIVE]: 'https://static.nrk.no/dh/module/plast-quiz/whales/v3/tier-five.png',
  [TIER_SIX]: 'https://static.nrk.no/dh/module/plast-quiz/whales/v3/tier-six.png'
}

export { imagePaths }



// WEBPACK FOOTER //
// ./src/v1/config/images.js